import React, { useState, useRef, useEffect } from "react";
import _ from "lodash";
import RadicavaDesignationForm from "./RadicavaDesignationForm";
import ShionogiLogo from "~/images/Shionogi.png";

const ShionogiDesignations = (props) => {
  const manufacturer_name = "mtpa";
  const vanityManufacturerName = "Shionogi";
  const [retailHasSelectedSpecialtyPharmacy, setRetailHasSelectedSpecialtyPharmacy] =
    useState(false);
  const [retailSelectedSpecialtyPharmacy, setRetailSelectedSpecialtyPharmacy] = useState();
  const [manufacturerFormDetails, setManufacturerFormDetails] = useState({
    mtpa: {},
  });

  useEffect(() => {
    props.setCompletedDesignations(isComplete());
  }, [manufacturerFormDetails]);

  const isComplete = () => {
    var completed = true;

    var openForms = _.map(manufacturerFormDetails, (manufacturer) => {
      return _.filter(manufacturer, (form) => {
        return form.open;
      });
    });

    // remove empty arrays and flatten
    var filteredForms = openForms.filter((e) => e.length).flat();

    if (filteredForms.length) {
      completed = _.every(filteredForms, ["completed", true]);
    }

    return completed;
  };

  const renderRadicava = () => {
    return (
      <RadicavaDesignationForm
        entities={props.entities}
        kind="radicava"
        manufacturerFormDetails={manufacturerFormDetails}
        setManufacturerFormDetails={setManufacturerFormDetails}
        manufacturer={manufacturer_name}
        manufacturerName={vanityManufacturerName}
        retailSelectedSpecialtyPharmacy={retailSelectedSpecialtyPharmacy}
        retailHasSelectedSpecialtyPharmacy={retailHasSelectedSpecialtyPharmacy}
        isBlocked={_.some(props.entities, (e) => e.blocked.includes("radicava"))}
      />
    );
  };

  return (
    <div>
      <div className="designation_form__section__header">
        <div className="designation_form__section__header__logo">
          <img src={ShionogiLogo} />
        </div>
        <div className="designation_form__section__header__title">{vanityManufacturerName}</div>
      </div>
      {renderRadicava()}
    </div>
  );
};

export default ShionogiDesignations;
